<script setup>
</script>

<template>
  <router-view/>
</template>

<style scoped lang="scss">
</style>
